module.exports = __webpack_public_path__ + "static/portfolio-3-5db82084321693688d8c325e185c04f9.jpg";